module.exports = __webpack_public_path__ + "media/src/img/watercolor-d96afd51e18ff45862a00becff7466b2.png";